import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import { ArrowBack } from '@mui/icons-material';
import Footer from '../../components/app/Footer';
import CustomPagination from '../utils/CustomPagination';
import history from '../../history';
import CustomSearchBar from '../utils/CustomSearchBar';
import toList from '../utils/ComponentUtil';
import useWindowDimensions from './WindowDimensions';


function SearchCards({ card, selected = '', placeholder = 'Search by names, locations, skills, jobs', api, heading = undefined, perRow = 3 }) {

    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(1);
    const [searchInput, setSearchInput] = useState('');
    const [data, setData] = useState([]);
    const [pages, setPages] = useState(1);
    const { width } = useWindowDimensions();
    const isMobile = () => { return width <= 768; }

    useEffect(() => {
        setPage(searchParams.get("page") ? parseInt(searchParams.get("page")) : 1);
        setSearchInput(searchParams.get("searchInput") ? searchParams.get("searchInput") : '');
    }, [searchParams]);

    useEffect(() => {
        const { pages, data } = api(page, searchInput);
        setData(data);
        setPages(pages);
    }, [page, searchInput]);

    const setCurrentPage = (page) => {
        setPage(page);
        history.push(window.location.pathname + "?" + (page ? 'page=' + page + '' : '') + (searchInput ? '&searchInput=' + searchInput + '' : ''));
    }

    const goBack = () => {
        history.back();
    }


    return (<div>
        <Navbar selected={selected}></Navbar>
        {
            heading ? heading : <div className='talent-group-wrp wrapper'>
                <div className='search-back-wrp' onClick={goBack}>
                    <ArrowBack />
                    <span>Search Results</span>
                </div>
                <CustomSearchBar placeholder={placeholder} />
            </div>
        }
        <div className='searchable-wrp'>
            <div className='search-results wrapper'>
                <div className='search-results-wrp'><CustomPagination page={page} pages={pages} onChange={setCurrentPage}></CustomPagination></div>
                <div className="cards-root" style={{ textAlign: 'center', gridTemplateColumns: 'repeat(' + (isMobile() ? 1 : perRow) + ', 1fr)'}}>
                    {toList([...data], card)}
                </div>
                <div className='search-results-wrp'><CustomPagination page={page} pages={pages} onChange={setCurrentPage}></CustomPagination></div>
            </div>
        </div>
        <Footer></Footer>
    </div>);
}

export default SearchCards;